import { render } from "./GetAccess.vue?vue&type=template&id=8074a39a"
import script from "./GetAccess.vue?vue&type=script&lang=js"
export * from "./GetAccess.vue?vue&type=script&lang=js"

import "./GetAccess.vue?vue&type=style&index=0&id=8074a39a&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__